export const GameStatus = Object.freeze({
  Initial: 'initial',
  Playing: 'playing',
  Pause: 'pause',
  Success: 'success',
  Failure: 'failure',
})

export const GameMode = Object.freeze({
  Hiragana: 'hiragana',
  Katakana: 'katakana',
  Mixed: 'mixed',
})

export const KanaCategory = Object.freeze({
  Seion: 'seion',
  Dakuon: 'dakuon',
  Handakuon: 'handakuon',
  YoOn: 'yo-on',
})